export default {
  PFAMasterList: [],
  PFAOrgList: [],
  PFAOrgSettings: {},
};
